import { Immutable } from "immer";
import React from "react";

import type { QuestionAnswerList as Value } from "@reactivated";

import styles from "./index.module.scss";

type IProps = Immutable<{
    value: Value;
}>;

/**
 * Faithful JSX transcription of the legacy sealy
 * ``components/qna/shopping_qna.html`` (#33285).
 */
export const QuestionAnswerList = (props: IProps): React.JSX.Element => {
    return (
        <section className={styles.shoppingQuestions}>
            <div className={styles.shoppingQuestionsContainer}>
                <h3>{props.value.title}</h3>
                {(props.value.qa_list ?? []).map((qa, index) => (
                    <div className={styles.shoppingQuestionsQa} key={index}>
                        <h5>{qa.question}</h5>
                        <p className={styles.shoppingQuestionsAnswer}>
                            {qa.answer}
                        </p>
                    </div>
                ))}
            </div>
        </section>
    );
};
